class DealBadge extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('.pbs-deal__trigger');
    this.popup = this.querySelector('.pbs-deal__popup');
    this.closeBtn = this.querySelector('.pbs-deal__close');
    this.overlay = this.querySelector('[data-role="deal-overlay"]');
    this.badgeCountdown = this.querySelector('[data-role="badge-countdown"]');
    this.countdownValues = {
        days: this.badgeCountdown?.querySelector('[data-unit="days"]'),
        hours: this.badgeCountdown?.querySelector('[data-unit="hours"]'),
        minutes: this.badgeCountdown?.querySelector('[data-unit="minutes"]'),
        seconds: this.badgeCountdown?.querySelector('[data-unit="seconds"]'),
    };
    this.popupCountdown = this.querySelector('[data-role="popup-countdown"]');
    this.endDate = new Date(this.dataset.end);
    this.groupId = this.dataset.group;

    try {
        this.i18n = JSON.parse(this.dataset.i18n || '{}');
    } catch (error) {
        this.i18n = {};
    }

    this.trigger.addEventListener('click', () => this.togglePopup());
    this.closeBtn?.addEventListener('click', () => this.closePopup());
    this.overlay?.addEventListener('click', () => this.closePopup());

    if (this.groupId) {
        document.querySelectorAll(`[data-deal-toggle="${this.groupId}"]`).forEach((el) => {
        el.addEventListener('click', () => this.togglePopup());
        });
    }

    document.addEventListener('click', (event) => {
        const clickedExternalToggle = this.groupId && event.target.closest(`[data-deal-toggle="${this.groupId}"]`);
        if (!this.contains(event.target) && !clickedExternalToggle) {
        this.closePopup();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
        this.closePopup();
        }
    });

    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  setOverlayOpen(open) {
    if (!this.overlay) return;
    this.overlay.hidden = !open;
    this.overlay.classList.toggle('is-open', open);
  }

  togglePopup() {
    const isOpen = this.popup.classList.toggle('is-open');
    this.popup.hidden = !isOpen;
    this.trigger.setAttribute('aria-expanded', String(isOpen));
    this.setOverlayOpen(isOpen);
  }

  closePopup() {
    this.popup.classList.remove('is-open');
    this.popup.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
    this.setOverlayOpen(false);
  }

  tick() {
    const diffMs = this.endDate.getTime() - Date.now();
    if (diffMs <= 0) {
      this.remove();
      return;
    }
    const totalSeconds = Math.floor(diffMs / 1000);
    const d = Math.floor(totalSeconds / 86400);
    const h = Math.floor((totalSeconds % 86400) / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    const pad = (n) => String(n).padStart(2, '0');

    if (this.countdownValues) {
      if (this.countdownValues.days) this.countdownValues.days.textContent = d;
      if (this.countdownValues.hours) this.countdownValues.hours.textContent = pad(h);
      if (this.countdownValues.minutes) this.countdownValues.minutes.textContent = pad(m);
      if (this.countdownValues.seconds) this.countdownValues.seconds.textContent = pad(s);
    }

    const dayLabel = this.i18n.day || 'd';
    const hourLabel = this.i18n.hour || 'h';
    const minuteLabel = this.i18n.minute || 'min';
    const secondLabel = this.i18n.second || 's';

    const timeText = d > 0
      ? `${d} ${dayLabel} ${pad(h)} ${hourLabel} ${pad(m)} ${minuteLabel} ${pad(s)} ${secondLabel}`
      : `${pad(h)} ${hourLabel} ${pad(m)} ${minuteLabel} ${pad(s)} ${secondLabel}`;

    if (this.popupCountdown) {
      const template = this.i18n.activeFor || 'Deal ends in [TIME].';
      this.renderWithLineBreaks(this.popupCountdown, template.replace('[TIME]', timeText));
    }
  }

  // Affiche le texte en transformant les <br> (bruts ou échappés par le filtre t) en vrais sauts de ligne,
  // sans jamais injecter de HTML
  renderWithLineBreaks(el, text) {
    const parts = String(text).split(/<br\s*\/?>|&lt;br\s*\/?&gt;|\n/i);
    el.replaceChildren();
    parts.forEach((part, i) => {
      if (i > 0) el.appendChild(document.createElement('br'));
      el.appendChild(document.createTextNode(part));
    });
  }
}

customElements.define('deal-badge', DealBadge);

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  document.querySelectorAll('[id^="Deal-Countdown-"]').forEach((countdownRow) => {
    const sectionId = countdownRow.id.replace('Deal-Countdown-', '');
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event.data.sectionId !== sectionId) return;
      const updated = event.data.html.getElementById(`Deal-Countdown-${sectionId}`);
      countdownRow.innerHTML = updated ? updated.innerHTML : '';
    });
  });
}